import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import * as _ from 'lodash'
import url from './apiUrl'

import VueRouter from 'vue-router'
const { isNavigationFailure, NavigationFailureType } = VueRouter
import router from '@/router'

export default {
  async post(path, data, config, isId = false) {
    let _config = {}, _data = {}
    if (Vue.$cookies.isKey('userInfo') && Vue.$cookies.get('userInfo')['tokenId']) {
      if (new Date(Vue.$cookies.get('userInfo')['expiredAt']).getTime() - new Date().getTime() <= 300000) {
        await store.dispatch('auth/userUpdateToken')
      }
      _config['headers'] = {
        'User-Token': Vue.$cookies.get('userInfo')['tokenId']
      }
      if (isId) {
        _data['id'] = Vue.$cookies.get('userInfo')['userId']
      } else {
        _data['user_id'] = Vue.$cookies.get('userInfo')['userId']
      }
    } else {
      router.push({
        name: 'Login',
        params: {
          pathName: window.location.pathname
        },
        query: {
          isExpired: true
        }
      }).catch(failure => {
        if (isNavigationFailure(failure, NavigationFailureType.redirected)) {
          throw failure
        }
      })
    }

    if (config && Object.keys(config).length) _.merge(_config, config)
    if (data && Object.keys(data).length) _.merge(_data, data)

    return await axios.post(path, _data, _config)
      .then(response => {
        return response
      })
      .catch(error => {
        return error
      })
  },
  async upload(file) {
    let _config = {}
    if (Vue.$cookies.isKey('userInfo') && Vue.$cookies.get('userInfo')['tokenId']) {
      if (new Date(Vue.$cookies.get('userInfo')['expiredAt']).getTime() - new Date().getTime() <= 300000) {
        await store.dispatch('auth/userUpdateToken')
      }
      _config['headers'] = {
        'User-Token': Vue.$cookies.get('userInfo')['tokenId']
      }
    } else {
      router.push({
        name: 'Login',
        params: {
          pathName: window.location.pathname
        },
        query: {
          isExpired: true
        }
      }).catch(failure => {
        if (isNavigationFailure(failure, NavigationFailureType.redirected)) {
          throw failure
        }
      })
    }
    const formData = new FormData();
    formData.append("myFile", file);
    formData.append("user_id", Vue.$cookies.get('userInfo')['userId']);
    return await axios.post(url.uploadImage, formData, {
      headers: {
        'User-Token': Vue.$cookies.get('userInfo')['tokenId']
      }
    })
      .then(response => {
        file.status = true
        return response
      })
      .catch(error => {
        file.status = false
        return error
      })
  }
}
